import { Dropdown, IDropdownOption } from '@fluentui/react';
import * as React from 'react';

import { EntityType} from '../DataOwnerModels/CDMRecord';
import * as FormStyle from '../Styles/form.styled';

export type EntityTypePropertyValue = {
  entityTypeId: string;
  entityTypeProperties: string[];
};

export type EntityTypePropertySelectorProps = {
  entityTypes: EntityType[];
  value: EntityTypePropertyValue | null;
  requiredProperty?: string | null;
  onChange(value: EntityTypePropertyValue): void;
  disabled?: boolean | undefined;
};

export function EntityTypePropertySelector(props: EntityTypePropertySelectorProps): React.ReactElement {
  const [properties, setProperties] = React.useState<string[]>([]);

  const handleEntityTypeChanged = (e: unknown, option: IDropdownOption) => {
    const entityTypeId = option.key.toString();

    props.onChange({
      entityTypeId,
      entityTypeProperties: [],
    });
    setProperties(props.entityTypes.find((et) => et.id === entityTypeId)?.properties || []);
  };

  const handleEntityTypePropertyChanged = (e: unknown, option: IDropdownOption) => {
    props.onChange({
      ...props.value,
      entityTypeProperties: option.selected
        ? [...(props.value.entityTypeProperties || []), option.key.toString()]
        : (props.value.entityTypeProperties || []).filter((p) => p !== option.key.toString()),
    });
  };

  return (
    <>
      <FormStyle.InputGroup>
        <Dropdown
          label="Entity type"
          options={props.entityTypes.map((entityType) => ({
            key: entityType.id,
            text: entityType.name,
          }))}
          disabled={props.disabled}
          placeholder="Select an entity type"
          selectedKey={props.value?.entityTypeId}
          onChange={handleEntityTypeChanged}
        />
      </FormStyle.InputGroup>

      <FormStyle.InputGroup>
        <Dropdown
          label="Properties"
          options={properties.map((property) => ({
            key: property,
            text: property,
            disabled: props.requiredProperty == property,
            selected: props.requiredProperty == property,
          }))}
          disabled={props.disabled || props.value?.entityTypeId == null}
          placeholder="Select properties"
          multiSelect
          selectedKeys={props.value?.entityTypeProperties}
          onChange={handleEntityTypePropertyChanged}
        />
      </FormStyle.InputGroup>
    </>
  );
}
